export default __webpack_public_path__ + "static/orangeline_logo-cada85aac4a4e525762a38c9e56451df.png";